'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.stringToBytes = stringToBytes;
exports.bytesToString = bytesToString;
exports.hexStringToBytes = hexStringToBytes;
exports.bytesToHexString = bytesToHexString;
exports.bytesToBase64 = bytesToBase64;
exports.base64ToBytes = base64ToBytes;
exports.appendUint8Array = appendUint8Array;
exports.isArrayEqual = isArrayEqual;
exports.bytesToBigInt = bytesToBigInt;
exports.randBytes = randBytes;
exports.sha256 = sha256;
exports.sha256File = sha256File;
exports.toBuffer = toBuffer;
exports.toUint8Array = toUint8Array;

var _textEncoding = require('text-encoding');

var _asmcryptoAll = require('asmcrypto.js/asmcrypto.all.js');

var asmcrypto = _interopRequireWildcard(_asmcryptoAll);

var _sjcl = require('sjcl');

var _sjcl2 = _interopRequireDefault(_sjcl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Convertor = {
	stringToBytes: stringToBytes,
	bytesToString: bytesToString,
	hexStringToBytes: hexStringToBytes,
	bytesToHexString: bytesToHexString,
	bytesToBase64: bytesToBase64,
	base64ToBytes: base64ToBytes,
	appendUint8Array: appendUint8Array,
	isArrayEqual: isArrayEqual,
	bytesToBigInt: bytesToBigInt,
	randBytes: randBytes,
	sha256: sha256,
	sha256File: sha256File,
	toBuffer: toBuffer,
	toUint8Array: toUint8Array
}; /* eslint-disable */
function stringToBytes(str) {
	return new _textEncoding.TextEncoder('utf-8').encode(str);
}

function bytesToString(bytes) {
	return new _textEncoding.TextDecoder('utf-8').decode(bytes);
}

function hexStringToBytes(str) {
	return asmcrypto.hex_to_bytes(str);
}

function bytesToHexString(uint8arr) {
	return asmcrypto.bytes_to_hex(uint8arr);
}

function bytesToBase64(uint8arr) {
	return asmcrypto.bytes_to_base64(uint8arr);
}

function base64ToBytes(base64) {
	return asmcrypto.base64_to_bytes(base64);
}

function appendUint8Array(arr1, arr2) {
	var combined = new Uint8Array(arr1.length + arr2.length);
	combined.set(arr1, 0);
	combined.set(arr2, arr1.length);
	return combined;
}

function isArrayEqual(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return false;
	}

	for (var i = arr1.length - 1; i >= 0; i--) {
		if (arr1[i] !== arr2[i]) {
			return false;
		}
	}
	return true;
}

function bytesToBigInt(uint8arr) {
	return new asmcrypto.BigNumber(uint8arr);
}

function randBytes(byteLength) {
	var rand = _sjcl2.default.random.randomWords(byteLength / 4);
	return new Uint8Array(_sjcl2.default.codec.bytes.fromBits(rand));
}

function sha256(data) {
	return asmcrypto.SHA256.bytes(data);
}

/**
 * Calculates a SHA256 hash for files incrementally.
 * @returns process(data: string | ArrayBuffer | Uint8Array) => void - Updates the hash with new data.
 * @returns finish() => Uint8Array - Returns the final hash value.
 */
function sha256File() {
	var sha256 = new asmcrypto.SHA256();
	return {
		process: function process(data) {
			return sha256.process(data);
		},
		finish: function finish() {
			return sha256.finish().result;
		}
	};
}

function toBuffer(uint8arr) {
	var buf = new Buffer(uint8arr.buffer);
	return buf;
}

function toUint8Array(buf) {
	var uint8arr = new Uint8Array(buf.length);
	for (var i = 0; i < buf.length; ++i) {
		uint8arr[i] = buf[i];
	}
	return uint8arr;
}

exports.default = Convertor;